import { useQuery } from '@tanstack/react-query';
import { DashboardQueryKey } from '../constants/dashboardQueryKeys';
import { settingsService } from '../services/settings/SettingsService';

export const settingsKeys = {
  public: () => [DashboardQueryKey.SETTINGS_PUBLIC] as const,
};

export function usePublicSettingsQuery() {
  return useQuery({
    queryKey: settingsKeys.public(),
    queryFn: () => settingsService.getPublic(),
    staleTime: 60_000,
  });
}
